import { render, staticRenderFns } from "./EarningsSkeleton.vue?vue&type=template&id=587a32af"
import script from "./EarningsSkeleton.vue?vue&type=script&lang=js"
export * from "./EarningsSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports